import randomString from '@/utils/random-string';

interface IconSendGradientProps {
  /** id must be unique for each instance */
  id?: string;
  size?: number;
  from?: string;
  to?: string;
}

const IconSendGradient = ({ id: _id, size = 16, from = '#5AE4FF', to = '#A7FF7B' }: IconSendGradientProps) => {
  const id = _id || `icon-add-gradient-${randomString(6)}`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none">
      <path
        d="M1.57728 13.6342C1.9013 13.9583 2.40984 13.9088 3.00837 13.6432L13.656 8.89095C13.9441 8.76494 14.1736 8.62543 14.3266 8.47242C14.6191 8.1799 14.6191 7.81988 14.3266 7.52736C14.1736 7.37435 13.9441 7.23484 13.656 7.10884L2.94987 2.33404C2.42784 2.10002 1.9058 2.03702 1.57728 2.36554C1.16326 2.77956 1.33877 3.23409 1.64029 3.79663L3.33239 6.96483C3.53041 7.34285 3.69692 7.49136 4.07494 7.50936L13.62 7.82888C13.7325 7.83338 13.791 7.90989 13.8001 7.99989C13.8001 8.0899 13.737 8.1619 13.6245 8.1664L4.07044 8.52192C3.71492 8.53542 3.54841 8.67493 3.33239 9.06196L1.67179 12.1537C1.35227 12.7432 1.15876 13.2157 1.57728 13.6342Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient id={id} x1="1.33325" y1="7.99938" x2="14.546" y2="7.99938" gradientUnits="userSpaceOnUse">
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IconSendGradient;
